import { ORPCError } from '@orpc/client';
import { createSerializationAdapter } from '@tanstack/react-router';

export const orpcErrorAdapter = createSerializationAdapter({
  key: 'orpc-error-adapter',
  test: (value: unknown) => value instanceof ORPCError,
  toSerializable: value => {
    return value.toJSON();
  },
  fromSerializable: value => {
    return new ORPCError(value.code, value);
  }
});
